export const ThemeStyle = {
  MODERN: "modern",
  STANDARD: "standard",
};
export const ThemeStyleRadius = {
  MODERN: 30,
  STANDARD: 16,
};
export const ThemeMode = {
  LIGHT: "light",
  DARK: "dark",
};
export const LayoutType = {
  FULL_WIDTH: "full-width",
  BOXED: "boxed",
  FRAMED: "framed",
};
export const MenuStyle = {
  DEFAULT: "default",
  STANDARD: "standard",
  ROUNDED: "rounded",
  ROUNDED_REVERSE: "rounded-reverse",
  CURVED_MENU: "curved-menu",
};
export const LayoutDirection = {
  RTL: "rtl",
  LTR: "ltr",
};
export const NavStyle = {
  DEFAULT: "default",
  BIT_BUCKET: "bit_bucket",
  STANDARD: "standard",
  DRAWER: "drawer",
  MINI: "mini",
  MINI_SIDEBAR_TOGGLE: "mini-sidebar-onToggleSidebar",
  HEADER_USER: "user-header",
  HEADER_USER_MINI: "user-mini-header",
  H_DEFAULT: "h-default",
  HOR_HEADER_FIXED: "hor-header-fixed",
  HOR_DARK_LAYOUT: "hor-dark-layout",
};
export const FooterType = {
  FIXED: "fixed",
  FLUID: "fluid",
};
export const HeaderType = {
  FLUID: "fluid",
  FIXED: "fixed",
};
export const RouteTransition = {
  NONE: "none",
  alpha: "alpha",
  SLIDE_LEFT: "slideLeft",
  SLIDE_RIGHT: "slideRight",
  SLIDE_UP: "slideUp",
  SLIDE_DOWN: "slideDown",
};
export const Fonts = {
  LIGHT: "300",
  REGULAR: "400",
  MEDIUM: "500",
  SEMI_BOLD: "600",
  BOLD: "700",
  VERY_BOLD: "900",
};

export const AuthType = {
  FIREBASE: "firebase",
  AWS_COGNITO: "aws_cognito",
  AUTH0: "auth0",
  JWT_AUTH: "jwt_auth",
};

export const RoutePermittedRole = [
  { name: "SuperAdmin", value: "SUPER_ADMIN" },
  { name: "Clients", value: "CLIENTS" },
  { name: "Vendor", value: "VENDOR" },
];

export const BASE_URL = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export const API_URL = `${BASE_URL}`;

export const riskScoreColor = [
  { name: "significant", color: "bg-green-500 text-white" },
  { name: "moderate", color: "bg-yellow-500 text-white" },
  { name: "low", color: "bg-gray-500 text-white" },
  { name: "extreme", color: "bg-red-600 text-white" },
  { name: "high", color: "bg-orange-500 text-white" },
  { name: "critical", color: "bg-red-700 text-white" }
];

export const riskImpactScore = [
  { name: "insignificant", value: 1 },
  { name: "minor", value: 2 },
  { name: "moderate", value: 3 },
  { name: "major", value: 4 },
  { name: "catastrophic", value: 5 },
];
export const riskLikelihoodScore = [
  { name: "rare", value: 1 },
  { name: "unlikely", value: 2 },
  { name: "possible", value: 3 },
  { name: "likely", value: 4 },
  { name: "almost certain", value: 5 },
];

export const customerConfig = [
  { name: "renewal", value: 12 }
]

export const riskCategory = [
  { name: "Operational Risk", value: "Operational Risk" },
  { name: "Regulatory Risk", value: "Regulatory Risk" },
  { name: "Security & Technology Risk", value: "Security & Technology Risk" },
  { name: "Strategic Risk", value: "Strategic Risk" }
]
export const riskSubCategory = [
  { name: "Data Breach", value: "data breach", category: "Security & Technology Risk" },
  { name: "System Downtime", value: "system downtime", category: "Security & Technology Risk" },
  { name: "Regulatory Non-compliance", value: "regulatory non compliance", category: "Regulatory Risk" },
  { name: "Market Fluctuations", value: "market fluctuations", category: "Strategic Risk" },
  { name: "Vendor Risk", value: "vendor risk", category: "Operational Risk" }
];
export const IMPACT_OPTIONS = [
  { value: "insignificant", label: "Insignificant (1)", score: 1 },
  { value: "minor", label: "Minor (2)", score: 2 },
  { value: "moderate", label: "Moderate (3)", score: 3 },
  { value: "major", label: "Major (4)", score: 4 },
  { value: "catastrophic", label: "Catastrophic (5)", score: 5 },
];

export const LIKELIHOOD_OPTIONS = [
  { value: "rare", label: "Rare (1)", score: 1 },
  { value: "unlikely", label: "Unlikely (2)", score: 2 },
  { value: "possible", label: "Possible (3)", score: 3 },
  { value: "likely", label: "Likely (4)", score: 4 },
  { value: "almost certain", label: "Almost Certain (5)", score: 5 },
];
export const RISK_RESPONSE_OPTIONS = ["Accept", "Reduce", "Transfer", "Avoid"];

export const RISK_TREATMENT_STATUS = [
  { value: 1, label: "Planned" },
  { value: 2, label: "In Progress" },
  { value: 3, label: "Implemented" }
];
export const TREATMENT_TYPES = [
  { value: "Preventive", label: "Preventive" },
  { value: "Detective", label: "Detective" },
  { value: "Corrective", label: "Corrective" }
];
export const RoleColour = [
  { role: "admin", color: "text-purple-900 bg-purple-300 dark:text-purple-100 dark:bg-purple-700" },
  { role: "customer_admin", color: "text-blue-900 bg-blue-300 dark:text-blue-100 dark:bg-blue-700" },
  { role: "company_user", color: "text-indigo-900 bg-indigo-300 dark:text-indigo-100 dark:bg-indigo-700" },
  { role: "auditor", color: "text-green-900 bg-green-300 dark:text-green-100 dark:bg-green-700" },
  { role: "end_user", color: "text-gray-900 bg-gray-300 dark:text-gray-100 dark:bg-gray-700" },
  { role: "security_analyst", color: "text-pink-900 bg-pink-300 dark:text-pink-100 dark:bg-pink-700" }
];
export const StatusColour = [
  { status: "active", color: "text-green-900 bg-green-300 dark:text-green-100 dark:bg-green-700" },
  { status: "inactive", color: "text-gray-900 bg-gray-300 dark:text-gray-100 dark:bg-gray-700" },
  { status: "suspended", color: "text-red-900 bg-red-300 dark:text-red-100 dark:bg-red-700" }
];

export const companyPerPage = 3;